'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { FlexColumn } from 'src/components/Atoms/FlexBox';
import { CHROME_HEIGHTS } from 'src/constants/styles';
import { styled } from '@mui/material/styles';
interface MainProps {
  children: React.ReactNode;
}
const StyledMain = styled(FlexColumn)<MainProps>(() => ({
  flexGrow: 1,
  display: 'flex',
  width: '100%',
  marginTop: `${CHROME_HEIGHTS.topBar}rem`,
  overflow: 'hidden'
})) as typeof FlexColumn;
const Main: React.FC<MainProps> = t0 => {
  const $ = _c(6);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== children || $[4] !== props) {
    t1 = <StyledMain component="main" {...props}>{children}</StyledMain>;
    $[3] = children;
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
export default Main;
export type { MainProps };